function isIntegerString(str) {
  // Convert the string to a number
  const num = Number(str);

  // Check if the conversion to number is successful and if the number is an integer
  return Number.isInteger(num) && str.trim() === String(num);
}


class QRReader {
    constructor(wrapperElement, options = {}) {
        this.wrapper = wrapperElement;
        this.options = {
            onScan: options.onScan || null,
            errorHandler: options.errorHandler || this._showFeedback.bind(this),
            continuous: options.continuous !== undefined ? options.continuous : true,
            debounceMs: options.debounceMs || 2000,
            scanMode: options.scanMode || "standalone",     // standalone / autocomplete / multicomplete
            filterType: options.filterType || null,
            digitalZoom: options.digitalZoom || 1,
            ...options
        };

        this.options.continuous = this.options.scanMode !== "autocomplete";

        // Datové struktury pro ukládání
        this.scannedData = {
            internalByType: {}, // { 'product': [id1, id2], 'user': [id3] }
            internalOther: [],
            external: []
        };
        this.scannedUrlsSet = new Set();

        this.isFrozen = false;
/*        this.lastScannedCode = null;
        this.lastScannedTime = 0;*/

        this._setupElements();
    }

    _setupElements() {
        this.video = document.createElement('video');
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d', { WILL_READ_FREQUENTLY: true });

        // Stylizace - video schováme, canvas bude náš "hledáček"
        this.video.style.display = 'none';
        this.wrapper.appendChild(this.canvas);
        this.wrapper.appendChild(this.video);

        // Kontejner pro chyby
        this.errorDisplay = document.createElement('div');
        this.errorDisplay.className = 'qr-error-msg'; // Styluj v CSS (např. červené pozadí, bílý text)
        this.errorDisplay.style.cssText = `
            position: absolute;
            top: 10px;
            left: 10px;
            right: 10px;
            background: rgba(0,0,0,0.7);
            color: white;
            padding: 8px;
            border-radius: 4px;
            text-align: center;
            display: none;
            pointer-events: none;
            font-family: sans-serif;
            z-index: 10;
        `;
        this.wrapper.style.position = 'relative'; // Aby absolutní pozicování fungovalo
        this.wrapper.appendChild(this.errorDisplay);
    }

    async start() {
        this.stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" }
        });
        this.video.srcObject = this.stream;
        this.video.setAttribute("playsinline", true);
        this.video.play();
        this.isRunning = true;
        requestAnimationFrame(() => this._tick());

        const observer = new MutationObserver(() => {
            if (!document.body.contains(this.wrapper)) {
                console.log("Čtečka byla odstraněna z DOMu, vypínám kameru...");
                this.stop();
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    _tick() {
        if (!this.isRunning)
            return; // Pokud jsme stopli, dál nic neděláme
        if (this.isFrozen) {
            requestAnimationFrame(() => this._tick());
            return;
        }
        if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
            this.canvas.height = Math.min(800, this.video.videoHeight);
            this.canvas.width = Math.min(800, this.video.videoWidth);
            console.log("this.video.videoHeight", this.video.videoHeight, "this.video.videoWidth", this.video.videoWidth);
            const vwidth = this.canvas.width / this.options.digitalZoom;
            const vheight = this.canvas.height / this.options.digitalZoom;
            const sourceX = (this.video.videoWidth - vwidth) / 2;
            const sourceY = (this.video.videoHeight - vheight) / 2;
            this.context.drawImage(this.video,
                sourceX, sourceY, vwidth, vheight,
                0, 0, this.canvas.width, this.canvas.height);

            const imageData = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height, {
                inversionAttempts: "dontInvert",
            });

            if (code) {
                this._handleDetectedCode(code);
            }
        }
        requestAnimationFrame(() => this._tick());
    }

    _flashError(loc, type, message) {
        this._drawOutline(loc, type === "error" ? "#FF0000" : "#FFFF00");
        this.canvas.classList.add('qr-shake');
        setTimeout(() => this.canvas.classList.remove('qr-shake'), 400);
        this.options.errorHandler(type, message);
    }

    _showFeedback(type, message) {
        this.errorDisplay.textContent = message;
        this.errorDisplay.style.display = 'block';
        this.errorDisplay.style.backgroundColor = type === "error" ? "rgba(220,0,0,0.8)" : "rgba(255,165,0,0.8)";

        // Zrušíme předchozí timeout, pokud tam byl, aby hláška nezmizela předčasně
        if (this.errorTimeout) clearTimeout(this.errorTimeout);

        this.errorTimeout = setTimeout(() => {
            this.errorDisplay.style.display = 'none';
        }, 3000); // Zmizí po 3 sekundách
    }

    _freeze(ms) {
        this.isFrozen = true;
        // Můžeme přidat vizuální overlay nebo efekt na canvas
        this.context.fillStyle = "rgba(255, 255, 255, 0.2)";
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);

        setTimeout(() => {
            this.isFrozen = false;
        }, ms);
    }

    _handleDetectedCode(code) {
        const now = Date.now();
        const isUrl = this._isValidUrl(code.data);
        this._freeze(this.options.debounceMs);

        // // Vykreslení rámečku (Zelený pro URL, Červený pro zbytek)
        // this._drawOutline(code.location, isUrl ? "#00FF00" : "#FF0000");

        if (!isUrl) {
            this._flashError(code.location, "error", "QR code is not a valid URL.")
            return;
        }

        if (this.options.mode === "standalone") {
            if (this.scannedUrlsSet.has(code.data)) {
                this._flashError(code.location, "warning", "QR code has already been scanned.");
                return;
            }
            this.scannedUrlsSet.add(code.data);
        }

        let recognizedItem = this._categorizeAndStore(code.data);
        if (recognizedItem.ok) {
            this._drawOutline(code.location, "#00FF00");
            if (this.options.onScan) this.options.onScan(code.data, recognizedItem, this.scannedData);
        } else {
            this._flashError(code.location, "warning", recognizedItem.msg);
        }
    }

    _isValidUrl(string) {
        try {
            const url = new URL(string);
            return url.protocol === "http:" || url.protocol === "https:";
        } catch (_) { return false; }
    }

    _categorizeAndStore(rawUrl) {
        const url = new URL(rawUrl);
        const currentHost = window.location.hostname;

        if (url.hostname.includes(currentHost)) {
            // Logika: <domena>/<typ>/<id>
            const pathParts = url.pathname.split('/').filter(p => p.length > 0);

            if (pathParts.length === 3 && isIntegerString(pathParts[2]) && pathParts[0] === 'detail') {
                const [_, type, id] = pathParts;
                if (this.options.filterType && this.options.filterType !== type) {
                    return {ok: false, msg: `QR code is not a valid URL for the selected type (${this.options.filterType}).`};
                }
                if (!this.scannedData.internalByType[type]) {
                    this.scannedData.internalByType[type] = [];
                }
                this.scannedData.internalByType[type].push({ id, fullUrl: rawUrl });
                return {ok: true, type: type, id: id, url: rawUrl};
            } else {
                if (this.options.mode === "standalone") {
                    this.scannedData.internalOther.push(rawUrl);
                    return {ok: true, type: "other", url: rawUrl};
                } else {
                    return {ok: false, msg: "QR is not a valid URL to a detail page."};
                }
            }
        } else {
            // this.scannedData.external.push(rawUrl);
            return {ok: false, msg: "QR code is not from the current domain."};
        }
    }

    _drawOutline(location, color) {
        const { topLeftCorner, topRightCorner, bottomRightCorner, bottomLeftCorner } = location;
        this.context.beginPath();
        this.context.moveTo(topLeftCorner.x, topLeftCorner.y);
        this.context.lineTo(topRightCorner.x, topRightCorner.y);
        this.context.lineTo(bottomRightCorner.x, bottomRightCorner.y);
        this.context.lineTo(bottomLeftCorner.x, bottomLeftCorner.y);
        this.context.closePath();
        this.context.lineWidth = 4;
        this.context.strokeStyle = color;
        this.context.stroke();
    }

    stop() {
        // 1. Zastavíme smyčku ticku
        this.isRunning = false;

        // 2. Zastavíme všechny stopy streamu (vypne se světýlko kamery)
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }

        // 3. Vyčistíme video element
        if (this.video) {
            this.video.pause();
            this.video.srcObject = null;
        }

        // 4. Vyčistíme canvas (volitelné)
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    setDigitalZoom(zoom) {
        this.options.digitalZoom = zoom;
    }
}

export default QRReader ;

/* USAGE
const reader = new QRReader(document.getElementById('camera-wrapper'), {
    debounceMs: 3000,
    onScan: (url, allData) => {
        console.log("Nový kód načten!", url);
        console.log("Aktuální databáze:", allData);
    }
});

reader.start();
 */